import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";
import { Button } from "@mcleod/components";
import { ActionPermission, ModelRow } from "@mcleod/core";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { RowDispatchControlFields } from "@mcleod/general/src/models/autogen/AutogenModelDispatchControl";
import { CommonContextMenuItems } from "@mcleod/general";

export class RowActionUpdateFields extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonUpdateFields;
    }

    override getButtonId(): string {
        return "buttonUpdateFields";
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["order_id", "movement_id", "manifest_id", "xferred_2_bill_date", "xferred_2_settle_date", "bill_date"];
    }

    override getMaxSelections(): keyof RowDispatchControlFields {
        return "max_a_update_selections";
    }

    override getMultiSelectPermission(): ActionPermission {
        return ActionPermission.ACTION_MULTI_UPDATE_FIELDS;
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        selectedRows.forEach(row => this.rowValidator(reasonMap, row));
    }

    private rowValidator(reasonMap: ReasonMap, modelRow: ModelRow) {
        const arrayField = "order_id";

        if (!this.hasUpdateOrderPermissions(modelRow, {xfer2BillDateField: "xferred_2_bill_date"})) {
            this.addReason(reasonMap, "order_update_perms", "You do not have permission to update orders [{0}].", modelRow, arrayField);
        }

        // Note: Transferred to settlements will always be false for available orders
        if (!this.hasUpdateMovementPermissions(modelRow, {xfer2SettleDateField: "xferred_2_settle_date", billDateField: "bill_date"})) {
            this.addReason(reasonMap, "move_update_perms", "You do not have permission to update movements for orders [{0}].", modelRow, arrayField);
        }

        if (!modelRow.isNull("manifest_id")) {
            this.addReason(reasonMap, "manifested", "Cannot update fields for manifests [{0}].", modelRow, "manifest_id");
        }
    }

    override execute(props: PlanningTableRowActionProps) {
        const selectedRows = props.selectedRows;
        const allowedFields = ["movement.brokerage", "orders.blnum", "orders.consignee_refno", "orders.operations_user",
            "orders.order_type_id", "orders.planning_comment", "orders.revenue_code_id"]
        CommonContextMenuItems.buttonUpdateFieldOnClick(selectedRows, false, allowedFields);
    }
}
